<template>
	<div
		class="media-lightbox-frame"
		:class="{ 'media-lightbox-frame--with-sidebar': withSidebar }"
		:style="{ height: height ?? undefined, maxHeight: maxHeight ?? undefined }"
		data-test-id="media-lightbox-frame">
		<slot />
	</div>
</template>

<script setup lang="ts">
	defineProps<{ height?: string | null; maxHeight?: string | null; withSidebar?: boolean }>();
</script>

<style scoped>
	.media-lightbox-frame {
		position: relative;
		display: flex;
		flex: 1;
		align-items: center;
		justify-content: center;
		min-width: 0;
		overflow: hidden;
		border-radius: 0.75rem;
		background: #000;
	}
	.media-lightbox-frame--with-sidebar {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
</style>
